import { CompanySettings } from '@innovyze/stylovyze';

export type HourCycleText = '12 hour clock' | '24 hour clock';

export interface CompanySettingsFull extends CompanySettings {
	hourCycle: HourCycleText;
}

export const getHourCycleBool = (
	values: CompanySettingsFull,
): CompanySettings => {
	const { hourCycle } = values;
	return {
		...values,
		hourCycle12: hourCycle === '12 hour clock',
	};
};

export const getHourCycleString = (
	values: CompanySettings,
): CompanySettingsFull => {
	const { hourCycle12 } = values;
	const newValues = {
		...values,
		hourCycle: (hourCycle12
			? '12 hour clock'
			: '24 hour clock') as HourCycleText,
	};
	return newValues;
};
